/**
 * Created by Victor Rojo on 27/8/18.
 */
import { Injectable, Optional }     from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';

import {Section} from "./Section";

@Injectable()
export class SectionService{

  private basePath = "api/v1/";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error: any): Promise<any> {
    console.log('An error occurred', error);
    return Promise.reject(error.message || error);
  }

  get(iPlaceId:string): Promise<any>{
    let url = this.basePath + "iplace/" + iPlaceId + "/section";
    return this.http.get(url)
      .toPromise()
      .then( res => res as Section[])
      .catch( error => this.errorHandler(error) );
  }

  getAll(): Promise<any>{
    let url = this.basePath + "iplace/all/section";
    return this.http.get(url)
      .toPromise()
      .then( res => res as any)
      .catch( error => this.errorHandler(error) );
  }

  getSection(sectionId:string): Promise<any>{
    let url = this.basePath + "section/" + sectionId;
    return this.http.get(url)
      .toPromise()
      .then( res => res as Section)
      .catch( error => this.errorHandler(error) );
  }

}
